import { forwardRef } from "react";
import { useStyle } from "lib/hooks";

function Select({ children, placeholder, attr, onChange }, ref) {
  const [style, setStyle] = useStyle(attr);
  const _onChange = ({ target: { value } }) => {
    setStyle(value);
    if (onChange) onChange();
  };
  const defaultValue = style;
  return (
    <div className="vc">
      <select onChange={_onChange} {...{ defaultValue, ref }}>
        <option value="" disabled>
          {placeholder}
        </option>
        {children.map((o) => (
          <option key={o}>{o}</option>
        ))}
      </select>
    </div>
  );
}

export default forwardRef(Select);
